import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e0870dc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flex flex-col gap-2" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-lg font-medium whitespace-nowrap overflow-hidden overflow-ellipsis" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = {
  key: 0,
  class: "absolute top-0 left-0 bottom-0 right-0 flex flex-col gap-4 bg-white justify-center items-center"
}
const _hoisted_6 = {
  key: 0,
  class: "absolute flex items-center justify-center top-0 bottom-0 left-0 right-0"
}
const _hoisted_7 = ["src"]
const _hoisted_8 = {
  key: 1,
  class: "absolute top-4 right-4 text-xs bg-dark-blue-300 rounded-full h-4 px-2 font-medium flex items-center justify-center shadow-md leading-none"
}
const _hoisted_9 = {
  key: 2,
  class: "absolute bottom-4 right-4 text-xs bg-dark-blue-300 rounded-full h-4 px-2 font-medium flex items-center justify-center shadow-md leading-none"
}
const _hoisted_10 = {
  key: 2,
  class: "flex items-center flex-col gap-4 justify-center text-center h-full relative"
}
const _hoisted_11 = { class: "text-center text-sm" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = {
  key: 0,
  class: "absolute top-0 right-0 text-xs bg-dark-blue-300 rounded-full h-4 px-2 font-medium flex items-center justify-center shadow-md leading-none"
}
const _hoisted_14 = {
  key: 1,
  class: "absolute bottom-0 right-0 text-xs bg-dark-blue-300 rounded-full h-4 px-2 font-medium flex items-center justify-center shadow-md leading-none"
}
const _hoisted_15 = {
  key: 3,
  class: "flex items-center flex-col gap-4 justify-center text-center h-full"
}

import { UiCard, UiLoader, SvgIcon } from '@/ui-kit';
import { useToggle } from '@vueuse/shared';
import { onBeforeMount, computed, ref } from 'vue';
import { Mail } from '../mail';
import { formatDate } from '@/utils';
import { useCompanyProfile } from '@/account';
import { useBilling } from '@/billing';
import { Mailbox } from '../mailbox';
import { addDays, differenceInDays } from 'date-fns';


export default /*#__PURE__*/_defineComponent({
  __name: 'MailPreview',
  props: {
    mail: null,
    selectedMailbox: null
  },
  setup(__props: any) {

const props = __props as {
	mail: Mail;
	selectedMailbox: Mailbox;
};



const [isLoading, setIsLoading] = useToggle(true);
const { isPaused } = useCompanyProfile();
const { getProductSettings } = useBilling();

onBeforeMount(() => {
	// if (props.mail.total_pages || !props.mail.document) {
	return setIsLoading(false);
	// }

	// const loadingTask = createLoadingTask(
	// 	props.mail.document.path
	// );
	// loadingTask.promise.then((pdf: PDFDocumentProxy) => {
	// 	setIsLoading(false);
	// });
});

const previewSrc = computed(() => {
	return props.mail.first_media
		? {
				type: 'img',
				src: props.mail.first_media
		  }
		: null;
});

const { isBalanceBelowThreshold } = useCompanyProfile();

const name = computed(() => {
	const value = `${
		props.mail.json_file.SENDER_COMPANY || ''
	} ${props.mail.json_file.SENDER_NAME || ''}`.trim();

	return value.length === 0 ? 'Not specified' : value;
});

const unlockPrice = computed(() => {
	const price = getProductSettings(
		props.selectedMailbox?.subscription_item
	);
	const currentUsage =
		props.selectedMailbox?.current_usage?.mail_pages ||
		0;
	const totalPages = props.mail?.total_pages || 0;
	const leftPagesToUse =
		(price?.pages_included || 0) - currentUsage;
	const overagePrice = price?.overage_price || 0;

	if (leftPagesToUse <= 0) {
		props.mail!.total_pages * overagePrice;
	}

	if (totalPages < leftPagesToUse) {
		return 0;
	}

	return (totalPages - leftPagesToUse) * overagePrice;
});

const imageLoaded = ref(false);

const expiringLabel = computed(() => {
	const shred_at = props.mail.marked_for_disposal_at;

	if (shred_at) {
		const diff = differenceInDays(
			addDays(new Date(shred_at), 30),
			new Date()
		);

		if (diff === 1) {
			return `Shred in ${diff} day`;
		}

		return `Shred in ${diff} days`;
	}

	const mail = props.mail.created_at;

	const diffInDays = differenceInDays(
		addDays(new Date(mail), 30),
		new Date()
	);

	if (diffInDays > 9) {
		return null;
	}

	if (diffInDays <= 0) {
		return 'Expired';
	}

	if (diffInDays === 1) {
		return `Expiring in ${diffInDays} day`;
	}

	return `Expiring in ${diffInDays} days`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(name)), 1),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(formatDate)(__props.mail.created_at)), 1)
    ]),
    _createVNode(_unref(UiCard), {
      theme: "white",
      class: "overflow-hidden shadow-md cursor-pointer aspect-a4",
      "content-class": "relative h-full"
    }, {
      default: _withCtx(() => [
        (_unref(isLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createTextVNode(" Loading mail... "),
              _createVNode(_unref(UiLoader))
            ]))
          : _createCommentVNode("", true),
        (
					__props.mail.first_media &&
					!__props.mail.is_hidden &&
					__props.mail.pages_generated
				)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_unref(previewSrc))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    (!imageLoaded.value)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          _createVNode(_unref(UiLoader))
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("img", {
                      class: "h-full w-full object-contain relative bg-white",
                      loading: "lazy",
                      src: _unref(previewSrc).src,
                      onLoad: _cache[0] || (_cache[0] = ($event: any) => (imageLoaded.value = true))
                    }, null, 40, _hoisted_7),
                    (_unref(expiringLabel))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref(expiringLabel)), 1))
                      : _createCommentVNode("", true),
                    (__props.mail.total_pages)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(__props.mail.total_pages) + " pages ", 1))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ], 64))
          : (
					__props.mail.is_hidden && __props.mail.pages_generated
				)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_unref(SvgIcon), {
                  name: "LockIcon",
                  class: "h-8 w-8"
                }),
                _createElementVNode("p", _hoisted_11, [
                  _createTextVNode(" Virtual mail is locked. "),
                  _hoisted_12,
                  (
							_unref(isBalanceBelowThreshold) &&
							_unref(unlockPrice) > 0
						)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _createTextVNode(" Top up your balance, then click to unlock. ")
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _createTextVNode(" Click to unlock mail. ")
                      ], 64))
                ]),
                (_unref(expiringLabel))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_13, _toDisplayString(_unref(expiringLabel)), 1))
                  : _createCommentVNode("", true),
                (__props.mail.total_pages)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(__props.mail.total_pages) + " pages ", 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_15, " Virtual mail is processing... "))
      ]),
      _: 1
    })
  ]))
}
}

})